export const MIN_SINGLE_PAYMENT_AMOUNT = 1
export const MAX_SINGLE_PAYMENT_AMOUNT = 99999999
